/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockOrderCheckWithSkuInfoVo } from './StockOrderCheckWithSkuInfoVo';
import {
    StockOrderCheckWithSkuInfoVoFromJSON,
    StockOrderCheckWithSkuInfoVoFromJSONTyped,
    StockOrderCheckWithSkuInfoVoToJSON,
    StockOrderCheckWithSkuInfoVoToJSONTyped,
} from './StockOrderCheckWithSkuInfoVo';

/**
 * 
 * @export
 * @interface ResponseStockOrderCheckWithSkuInfoVo
 */
export interface ResponseStockOrderCheckWithSkuInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseStockOrderCheckWithSkuInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseStockOrderCheckWithSkuInfoVo
     */
    message?: string;
    /**
     * 
     * @type {StockOrderCheckWithSkuInfoVo}
     * @memberof ResponseStockOrderCheckWithSkuInfoVo
     */
    data?: StockOrderCheckWithSkuInfoVo;
}

/**
 * Check if a given object implements the ResponseStockOrderCheckWithSkuInfoVo interface.
 */
export function instanceOfResponseStockOrderCheckWithSkuInfoVo(value: object): value is ResponseStockOrderCheckWithSkuInfoVo {
    return true;
}

export function ResponseStockOrderCheckWithSkuInfoVoFromJSON(json: any): ResponseStockOrderCheckWithSkuInfoVo {
    return ResponseStockOrderCheckWithSkuInfoVoFromJSONTyped(json, false);
}

export function ResponseStockOrderCheckWithSkuInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseStockOrderCheckWithSkuInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : StockOrderCheckWithSkuInfoVoFromJSON(json['data']),
    };
}

export function ResponseStockOrderCheckWithSkuInfoVoToJSON(json: any): ResponseStockOrderCheckWithSkuInfoVo {
    return ResponseStockOrderCheckWithSkuInfoVoToJSONTyped(json, false);
}

export function ResponseStockOrderCheckWithSkuInfoVoToJSONTyped(value?: ResponseStockOrderCheckWithSkuInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': StockOrderCheckWithSkuInfoVoToJSON(value['data']),
    };
}

